export default {
  title: {
    name: "美信小程序"
  },
  mxTitle: '美信',
  mxHarmonyTitle: '美信鸿蒙版',
  mxLongContent: '美信与你一起成长',
  locale: '中文',
  problem: '常见问题',
  help: '意见反馈',
  guide: '操作指引',
  welcome: "欢迎",
  downloadNow: '立即下载',
  netError: '网络异常,请稍后重试',
  codeLargeTip: '（移动端下载二维码可点击放大查看）',
  ok: '我知道了',
  clickRightTopIOS: '点击右上角菜单，在Safari中打开',
  clickRightTopAndroid: '点击右上角菜单，在浏览器中打开',
  toProblem: '_problem-zh',
  mideaConnect: '由于美信属于企业应用，首次安装后需要您信任应用证书。请进入手机 设置 > 通用 > VPN与设备管理 > Midea Group Co.,Ltd 点击信任',
  phoneSuccessTips: '点击“安装”后，您可以回到桌面查看安装的情况',
  mx: {
    introduce: '美信是美的集团自研的、服务于美的员工和外协员工的企业级沟通协作一体化平台，集会话沟通、视频会议、共享文档、小程序、资讯互动等服务于一体，助力于员工之间的高效沟通和协作。',
    downTips: '下载美信客户端',
    ios: 'iOS',
    android: 'Android & 鸿蒙\n(不含鸿蒙5.0)',
    harmony: '鸿蒙Next\n(原生鸿蒙)',
    mac: 'macOS',
    window: 'Windows',
    androidDownload: '卓易通版本下载',
    harmonyDownload: '纯血鸿蒙版本下载',
    downloadClick: '立即下载',
    downloadScan: '扫码立即下载',
    scanCodeDown: '扫描二维码下载手机客户端',
    harmonyScan: '美信扫描二维码进群下载\n或\n使用美信-搜索输入下方群号可进群:',
    copySuccess: '复制成功',
    copyErrorTitle: '复制失败',
    copyError: '1.检查浏览器的权限设置，确保有剪贴板写入权限;\n2.可能浏览器不支持复制，建议更换浏览器尝试。',
    mobile_harmonyScan: '使用美信扫一扫进群下载',
    mobile_joinGroup_long: '使用美信-搜索输入下方群号可进群:',
    mobile_getHarmony: '获取原生鸿蒙版本',
    mobile_getHarmonyBeta: '获取鸿蒙内测版',
    hormony_group: '鸿蒙美信交流群',
    downloadLink: '下载链接',
    downloadWithBrowser: '使用浏览器扫码立即下载',
  },
  vpn: {
    title: '美的VPN',
    introduce: 'VPN是美的集团内部使用的网络工具，可以协助员工在居家、出差等场景下进行远程办公，提高工作效率。',
    tips: '长按保存至相册或识别二维码进行下载',
    downTips: '下载VPN',
    configureSeq: '安装指引',
    configureDownload: '配置文件',
    pcCoreAliens: '切换为中国境外版',
    pcCoreZH: '切换为中国境内版',
    iphoneCoreAliens: '海外客户端下载',
    iphoneCoreZH: '内地客户端下载',
    downloadAliens: '扫码立即下载',
    downloadZH: '扫码立即下载',
  },
  MacDownload: {
    title: '下载更适合你 Mac 的美信版本',
    text1: '美信针对采用Intel芯片的Mac电脑和采用Apple芯片的Mac电脑都进行了优化，使用正确的版本有助于降低资源消耗，提升软件性能。',
    text2: '如何确定你的Mac电脑芯片类型?',
    "text2-intel": '检测到您的电脑芯片类型是Intel（英特尔），推荐您使用Intel芯片版本美信',
    "text2-apple": '检测到您的电脑芯片类型是Apple，推荐您使用Apple芯片版本美信',
    text3: '',
    text4: '*如果你无法确认芯片版本，可直接下载intel版',
    macIntel: '下载Intel芯片版本',
    macM1: '下载Apple芯片版本',
    aboutLeft: '1. 点击左上角苹果菜单，选择 ',
    about: '关于本机',
    aboutRight: '',
    gaishuLeft: '2. 在 ',
    gaishu: '概览',
    chuliqiLeft: '页面的',
    chuliqi: '处理器',
    typeLeft: ' 一栏，查看',
    type: '芯片类型',
    intelLeft: ' 是"',
    intel: 'Intel（英特尔）',
    appleLeft: '"还是"',
    apple: 'Apple',
    appleRight: '"，并选择下载对应版本',
    img1: require('../assets/M1/img1_cn.png'),
    img2: require('../assets/M1/img2_cn.png'),
    img3: require('../assets/M1/img3_cn.png'),
  }
}